// @ts-nocheck

export const localeCodes =  [
  "en",
  "da"
]
export const localeLoaders = {
  en: [
    {
      key: "locale_en_46json_15c95735",
      load: () => import("#nuxt-i18n/15c95735" /* webpackChunkName: "locale_en_46json_15c95735" */),
      cache: true
    },
    {
      key: "locale_en_46json_abcc5708",
      load: () => import("#nuxt-i18n/abcc5708" /* webpackChunkName: "locale_en_46json_abcc5708" */),
      cache: true
    },
    {
      key: "locale_en_46json_ba7f0cc1",
      load: () => import("#nuxt-i18n/ba7f0cc1" /* webpackChunkName: "locale_en_46json_ba7f0cc1" */),
      cache: true
    },
    {
      key: "locale_en_46json_3dc1aedf",
      load: () => import("#nuxt-i18n/3dc1aedf" /* webpackChunkName: "locale_en_46json_3dc1aedf" */),
      cache: true
    },
    {
      key: "locale_en_46json_15d46799",
      load: () => import("#nuxt-i18n/15d46799" /* webpackChunkName: "locale_en_46json_15d46799" */),
      cache: true
    },
    {
      key: "locale_i18n_45brand_46en_46json_f3a58705",
      load: () => import("#nuxt-i18n/f3a58705" /* webpackChunkName: "locale_i18n_45brand_46en_46json_f3a58705" */),
      cache: true
    },
    {
      key: "locale_en_46json_31fea06e",
      load: () => import("#nuxt-i18n/31fea06e" /* webpackChunkName: "locale_en_46json_31fea06e" */),
      cache: true
    },
    {
      key: "locale_en_46json_5c8afd15",
      load: () => import("#nuxt-i18n/5c8afd15" /* webpackChunkName: "locale_en_46json_5c8afd15" */),
      cache: true
    }
  ],
  da: [
    {
      key: "locale_da_46json_9b093b54",
      load: () => import("#nuxt-i18n/9b093b54" /* webpackChunkName: "locale_da_46json_9b093b54" */),
      cache: true
    },
    {
      key: "locale_da_46json_d2d3586d",
      load: () => import("#nuxt-i18n/d2d3586d" /* webpackChunkName: "locale_da_46json_d2d3586d" */),
      cache: true
    },
    {
      key: "locale_da_46json_169beb17",
      load: () => import("#nuxt-i18n/169beb17" /* webpackChunkName: "locale_da_46json_169beb17" */),
      cache: true
    },
    {
      key: "locale_da_46json_eec30648",
      load: () => import("#nuxt-i18n/eec30648" /* webpackChunkName: "locale_da_46json_eec30648" */),
      cache: true
    },
    {
      key: "locale_da_46json_89be4ac1",
      load: () => import("#nuxt-i18n/89be4ac1" /* webpackChunkName: "locale_da_46json_89be4ac1" */),
      cache: true
    }
  ]
}
export const vueI18nConfigs = []
export const normalizedLocales = [
  {
    code: "en",
    language: undefined
  },
  {
    code: "da",
    language: undefined
  }
]

